

































import { Component } from 'vue-property-decorator'
import AbpBase from '@/lib/abpbase'
import HotSearchKeyWord from '@/api/mall/hotSearch/index'
import PicModal from '@/components/upload/picModal.vue'
import MallConfig from '@/api/mall/mallConfig/index'
import SelectUrl from '@/components/selectUrl/index.vue'
@Component({
  components: {
    PicModal,
    SelectUrl,
  },
})
export default class EditHotSearchKeyWord extends AbpBase {
  form = {
    keyWord: null,
    icon: null,
    link: null,
    clickCount: 0,
    displayOrder: 0,
    published: false,
  }

  ruleForm = {
    keyWord: [{ required: true, message: '请输入热门搜索词', trigger: 'blur' }],
    // link: [{ required: true, message: '请选择链接', trigger: 'blur' }]
  }

  created() {
    this.getrHotSearchKeyWord()
  }

  urlChange(e) {
    this.form.link = e
  }

  /**
   * 获取热门搜索词
   */
  getrHotSearchKeyWord() {
    let id = this.$route.query['id']
    if (id) {
      HotSearchKeyWord.getrHotSearchKeyWord(id.toString()).then((res) => {
        this.form = res.data
      })
    }
  }

  picChange(e) {
    this.form.icon = e[0].url
  }

  submit() {
    let vm = this
    let form: any = vm.$refs.form
    form.validate((valid) => {
      if (valid) {
        let id = vm.$route.query['id'] ? vm.$route.query['id'].toString() : null
        HotSearchKeyWord.updateHotSearchKeyWord(vm.form, id).then((res) => {
          vm.$router.push({
            name: 'hotSearchKeyWord',
          })
        })
      }
    })
  }
}
